<template>
  <div class="p-content-page">
    <page-title>Notifications</page-title>

    <loading v-if="loading"/>

    <div class="row" v-else>
      <div class="col-xs-12 col-md-8">
        <section-block class="p-0" v-if="notifications.length < 1">
          <template slot="header">
            <h3>Notifications</h3>
          </template>
          <p>You currently have no notifications</p>
        </section-block>
        <section-block class="p-0" v-else>
          <template slot="header">
            <h3 class='p-10' v-if="unread.length > 0">
              <notification-count :count="unread.length"/>
              {{' '}}New
            </h3>
            <h3 class='p-10' v-else>New</h3>
          </template>
          <template slot="actions">
            <base-button asLink @click="markAllRead" v-if="unread.length > 0">Mark all as Read</base-button>
          </template>
          <notification-list v-if="unread.length > 0 || read.length > 0" class="negative-margin">
            <li v-if="unread.length == 0" class="p-10">You have no unread notifications</li>
            <li v-for="item in unread" :key="item.id">
              <notification-card v-bind="item">
                <template slot="actions">
                  <dropdown>
                    <dropdown-action icon="view" @click="viewNotification(item, false)">Mark as Read</dropdown-action>
                    <dropdown-action icon="cross" @click="deleteNotification(item.self)">Delete</dropdown-action>
                  </dropdown>
                </template>
              </notification-card>
            </li>
            <li class="p-10" v-if="read.length > 0">
              <h3>Earlier</h3>
            </li>
            <li v-for="item in read" :key="item.id">
              <notification-card v-bind="item">
                <template slot="actions">
                  <dropdown>
                    <dropdown-action icon="cross" @click="deleteNotification(item.self)">Delete</dropdown-action>
                  </dropdown>
                </template>
              </notification-card>
            </li>
          </notification-list>
        </section-block>
      </div>
      <div class="u-hide-mobile col-md-4">
        <article>
          <section-block headerHidden>
            <profile-card large noBorder/>
          </section-block>
        </article>

        <base-container title="Latest Trust News" viewLink="/news" withGradient>
          <base-scroll-list>
            <ol v-if="articles.length > 0">
              <li v-for="(article, index) in articles" :key="index">
                <card-list v-bind="article" @click="handleNewsClick(article)"></card-list>
              </li>
            </ol>
            <p v-else>There are no articles</p>
          </base-scroll-list>
        </base-container>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Dropdown from "@/components/Dropdown";
import DropdownAction from "@/components/DropdownAction";
import NotificationCount from "@/components/BaseNotificationCount";
import NotificationCard from "@/components/NotificationCard";
import NotificationList from "@/components/UserNotificationList";
import CardList from "@/components/Containers/BaseCardList";
import {
  ProfileCard,
  BaseContainer,
  BaseScrollableList as BaseScrollList
} from "@/components/Containers";
export default {
  name: "NotificationsIndex",
  components: {
    NotificationCount,
    NotificationCard,
    NotificationList,
    BaseContainer,
    BaseScrollList,
    ProfileCard,
    CardList,
    Dropdown,
    DropdownAction
  },

  data() {
    return {
      loading: true
    };
  },

  computed: {
    ...mapState("News", ["articles"]),
    ...mapState("userNotifications", ["notifications"]),
    ...mapGetters("userNotifications", ["read", "unread"])
  },
  methods: {
    /**
     * Change the status of the read notifications to unread, remove from unread array,
     * merge into others
     * TODO: Date ordering?
     */
    markAllRead() {
      this.$store.dispatch("userNotifications/markAllAsRead");
    },
    viewNotification(item, gotoLink) {
      this.$store.dispatch("userNotifications/read", item.self).then(resp => {
        if (gotoLink) {
          /**
           * If it is an admin notification, go to the edit screen
           * If it is not, go to the actual resource
           */
          const type = item.self;

          let url;

          if (type.includes("news/article")) {
            url =
              item.admin === 1
                ? `/admin/news/${item.resource.id}/edit`
                : item.resource.self;
          }
          if (type.includes("schedule/event")) {
            url =
              item.admin === 1
                ? `/admin/events/edit/${item.resource.id}`
                : item.resource.self;
          }
          if (type.includes("content/page")) {
            url =
              item.admin === 1
                ? `/admin/content/pages/${item.resource.id}/edit`
                : `/content/page/${item.resource.page_url}`;
          }

          this.$router.push({ path: url });
        }
      });
    },
    deleteNotification(self) {
      this.$store.dispatch("userNotifications/delete", self).then(resp => {
        this.$store.dispatch(
          "notifications/create",
          {
            body: `The notification was deleted`,
            type: "success"
          },
          { root: true }
        );
      });
    }
  },
  created() {
    this.$store.commit("News/SET_RESULT_COUNT", 5);
    this.$store
      .dispatch("News/list")
      .then(() => {})
      .catch(() => console.log("news fail"));

    this.$store.dispatch("userNotifications/list").then(() => {
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.negative-margin {
  @media screen and (min-width: 1024px) {
    margin: -1em;
  }
}
</style>
